import React from 'react';
import classNames from 'classnames';
export const Stepper = ({ steps, activeStep, className, }) => (React.createElement("div", { className: classNames('flex items-center gap-2 w-full', className) }, Array.from({ length: steps }, (_, index) => (React.createElement("div", { className: classNames('h-1 flex-1 rounded-full transition-colors', {
        'bg-primary-20': index < activeStep,
        'bg-gray-40': index >= activeStep,
    }), key: index })))));
